import React from 'react';
import { View } from 'react-native';

import ThemedText from './ThemedText';

interface InlineErrorProps {
  message: string | null;
  visible?: boolean;
  testID?: string;
}

export const InlineError: React.FC<InlineErrorProps> = ({ message, visible = true, testID }) => {
  if (!message || !visible) {
    return null;
  }

  return (
    <View className='bg-login-red-10 rounded-lg p-3 px-9 mt-2 mb-4' testID={testID}>
      <ThemedText type='bodySmall' className='text-login-red-50 text-center'>
        {message}
      </ThemedText>
    </View>
  );
};
